import React from "react";
import styled from "styled-components";
import Loading from "@ui-kit/loading";
import "mapbox-gl/dist/mapbox-gl.css";

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  > div:first-child {
    position: relative;
    width: 100%;
    height: 100%;

    > div:first-child {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
    }
  }
`;

const Footer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 28px;
  display: flex;
  align-items: center;
  transition: 0.3s;
  border-radius: 4px;
`;

export interface ChartyMapLayoutIProps {
  mapWrapper: React.MutableRefObject<HTMLDivElement>;
  footer: React.ReactNode;
  tooltip: React.ReactNode;
  map: React.ReactNode;
  loading?: boolean;
}

export default function ChartyMapLayout({
  mapWrapper,
  footer,
  tooltip,
  loading,
  map,
}: ChartyMapLayoutIProps) {
  return (
    <Container ref={mapWrapper}>
      <div>
        {map}
        {loading && <Loading />}
        {!!footer && <Footer>{footer}</Footer>}
        {tooltip}
      </div>
    </Container>
  );
}
